import React, { useState } from "react"
import { Link, useHistory } from "react-router-dom"
import DeleteModal from "../../../../components/Common/DeleteModal"
import { usePagination } from "../../../../hooks/usePagination"
import ResultHandler from "../../../../components/ResultHandler"
import PaginationHandler from "../../../../components/PaginationHandler"
import { deleteCollection, getCollections, importCollections } from "../../../../api/collections"
import TableHeaderHandler from "../../../../components/TableHeaderHandler"
import { useTranslation } from "react-i18next"
import { useResponse } from "../../../../hooks/useResponse"
import TableAction from "../../../../components/TableAction"
import EmptyData from "../../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../../api/permissions";
import ImportCard from "../../../../components/ImportModal"
import { useParams } from "react-router-dom"
import moment from "moment"
import TableFilter from "../../../../components/TableFilter"
import { Button } from "reactstrap"


export default function CollectionsTable() {

  const { t } = useTranslation()
  let navigate = useHistory()
  const {poolId} = useParams()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta,
  } = usePagination(getCollections, {poolId})


  //// delete 
  const [show, setShow] = useState(false)

  function onCloseClick() {
    setShow(false)
  }

  const [deletingCollection, setDeletingCollection] = useState(null)

  const { setData } = useResponse(deleteCollection, () => {
    setShow(false)
    setDeletingCollection(null)
    setPayload({poolId, refetch: true})
  })

  function onDeleteClick() {
    setData({ type: "add", data: deletingCollection })
  }

  ///////////

 // Filters
 const filterTypes = [
  {key: "isInvoiced", label: "Invoiced", type: "select", options: [
    {label: "All", value: "all"},
    {label: "Invoiced", value: true},
    {label: "Not Invoiced", value: false},
  ]},
]

  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.POULE_CREATE}
        setPage={setPage}
        setPerPage={setPerPage}
        addUrl={"/add-collection/"+poolId}
      >
     
      </TableHeaderHandler>

      <TableFilter
        filterTypes={filterTypes}
        onFilter={(filters) => setMeta({ page: 1, payload: {poolId, ...filters}})}
      />

      {/* <ImportCard /> */}
      
      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>Name</Th>
                <Th>From</Th>
                <Th>To</Th>
                <Th>Total</Th>
                <Th>Invoice</Th>
                <Th style={{ width: "25%" }}>{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.hoursCollections.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>{row.name}</Td>
                      <Td>{moment.utc(row.date_from).format("DD MMM YYYY")}</Td>
                      <Td>{moment.utc(row.date_to).format("DD MMM YYYY")}</Td>
                      <Td>{row.hours.reduce((acc, h) => acc + h.hoursLength,0)}</Td>
                      <Td>
                        {row.invoicable.invoice_id
                          ? <Button size="sm" onClick={() => navigate.push('/invoices/'+ row.invoicable.invoice_id )} color="primary">Invoiced</Button>
                          : <Button size="sm" onClick={() => navigate.push('/invoices/preview/'+ row.invoicable.contract_id )} color="warning">Not Invoiced</Button>
                        }
                      </Td>
                      <Td>
                        <TableAction
                          hasEdit={true}
                          hasDelete={true}
                          editPermission={PERMISSIONS.COMPANY_EDIT}
                          deletePermission={PERMISSIONS.COMPANY_DELETE}
                          type="collection"
                          id={row.id}
                          editUrl={'/edit-collection/'+row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingCollection}
                        />
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading &&
            <EmptyData empty={response.data && response.data.hoursCollections.length === 0} msg="No Collections Found." />
          }
          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}


          <ResultHandler error={error} loading={loading} />

        </div>
      </div>
    </>
  )
}
